import { render, staticRenderFns } from "./RfB.vue?vue&type=template&id=43e9e232&"
import script from "./RfB.vue?vue&type=script&lang=js&"
export * from "./RfB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports